import { companiesAPI } from '../lib/api';
import { getCurrentCompanyId } from '../utils/auth';

// Mock data fallback for when API calls fail
const mockCompanies = [
  {
    id: 1,
    name: 'Acme Corporation',
    email: 'admin@acme.com',
    phone: '+1-555-0123',
    address: '123 Business St, City, State 12345',
    taxId: 'TAX123456',
    currency: 'USD',
    fiscalYearEnd: '2024-12-31',
    status: 'active',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z'
  }
];

export const getCompanies = async () => {
  try {
    const response = await companiesAPI.getAll();
    return response.data || [];
  } catch (error) {
    console.error('Error in getCompanies, using mock data:', error);
    return mockCompanies;
  }
};

export const createCompany = async (companyData) => {
  try {
    const response = await companiesAPI.create(companyData);
    return response.data;
  } catch (error) {
    console.error('Error creating company:', error);
    throw error;
  }
};

export const updateCompany = async (id, companyData) => {
  try {
    const response = await companiesAPI.update(id, companyData);
    return response.data;
  } catch (error) {
    console.error('Error updating company:', error);
    throw error;
  }
};

export const deleteCompany = async (id) => {
  try {
    await companiesAPI.delete(id);
    return true;
  } catch (error) {
    console.error('Error deleting company:', error);
    throw error;
  }
};

export const updateCompanySubscription = async (id, subscriptionData) => {
  try {
    const response = await companiesAPI.update(id, subscriptionData);
    return response.data;
  } catch (error) {
    console.error('Error updating company subscription:', error);
    throw error;
  }
};

export const getCompanyConfiguration = async (companyId = null) => {
  try {
    const actualCompanyId = companyId || getCurrentCompanyId();
    if (!actualCompanyId) {
      console.warn('No company ID available, using mock configuration');
      return {
        companyId: 'mock-company-1',
        fiscalYearStart: '2024-01-01',
        defaultCurrency: 'USD',
        taxSettings: {},
        accountingMethod: 'accrual'
      };
    }
    
    // For now, return mock configuration since this endpoint might not exist
    return {
      companyId: actualCompanyId,
      fiscalYearStart: '2024-01-01',
      defaultCurrency: 'USD',
      taxSettings: {},
      accountingMethod: 'accrual'
    };
  } catch (error) {
    console.error('Error in getCompanyConfiguration:', error);
    throw error;
  }
};

export const updateCompanyConfiguration = async (companyId = null, configData) => {
  try {
    const actualCompanyId = companyId || getCurrentCompanyId();
    if (!actualCompanyId) {
      throw new Error('No company ID available');
    }
    
    // For now, return the updated config since this endpoint might not exist
    return { companyId: actualCompanyId, ...configData };
  } catch (error) {
    console.error('Error updating company configuration:', error);
    throw error;
  }
};
